import { useState } from "react";
import { IUser } from "../../../store/groups/types";
import { IDataSourceFields } from "../dataSourceForm";
import Button from "@mui/material/Button";
import CustomizedDialogs from "../../atoms/modal/customizedDialogs";
import { FormControl, Grid, Stack } from "@mui/material";
import { DataField } from "../../atoms";
import { useNavigate } from "react-router-dom";
import { postDataSelector } from "../../../store/dataSource/selectors";
import { useSelector } from "react-redux";

interface ISchemaSelectionProps {
    disableSchemaBtn?: boolean;
    dataSourceData: IDataSourceFields;
    accessControlGroup: string[];
    dataStewardGroup: string;
    dataStewardIDs: IUser[];
    endpoint: string;
    mode?: string;
    sourceID?: string;
    spokeName?: string;
}

const FoundrySelection = (props: ISchemaSelectionProps) => {

    const [firstOpenModel, setFirstOpenModel] = useState<boolean>(false);
    const [datasetRID, setDatasetRID] = useState("");
    const [selectedTable, setSelectedTable] = useState<Array<string>>([]);
    const navigate = useNavigate();
    const [dataSetError, setDataSetError] = useState(false);

    const dataSource = useSelector(postDataSelector);

    const openDialog = () => {
        setFirstOpenModel(true);
    };

    const closeModal = () => {
        setFirstOpenModel(false);
        setDatasetRID("");
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDatasetRID(event.target.value);
        setSelectedTable(prevState => [...prevState, event.target.value]);
        setDataSetError(false);
    }

    const openExtractors = (type: string) => {
        if (datasetRID) {
            navigate("/ConfigureTables", {
                state: {
                    selectedTables: selectedTable, selectedSchema: null, dataSourceData: props.dataSourceData,
                    accessControlGroup: props.accessControlGroup, dataStewardGroup: props.dataStewardGroup,
                    endpoint: props.endpoint.replace('https://', ''),
                    connection: "Foundry",
                    dataStewardIDs: props.dataStewardIDs, dataSourceName: dataSource?.sourceName, spokeName: props.spokeName,
                    foundryDatasetRID: datasetRID
                }
            });
            setDatasetRID("");
        }
        else { 
            setDataSetError(true);
        }
    };

    return (
        <>
            <Button id="btnSetSchema"
                color="primary"
                variant="contained"
                disabled={props.disableSchemaBtn}
                onClick={openDialog}
                style={{ marginRight: '1em' }}
            >
                Set Schema
            </Button>
            <CustomizedDialogs
                dialogHeight='200px'
                modalSize="sm"
                key="schema"
                modalTitle="Foundry DatasetRID"
                isOpen={firstOpenModel}
                onClose={closeModal}
                footerAction={
                    <Stack direction="row" spacing={2}>
                        <Button id="btnSetSchemaClose" color="primary" variant="contained" onClick={closeModal}>
                            Close
                        </Button>
                        <Button id="btnSetSchemaClose"
                            color="primary"
                            variant="contained"
                            onClick={() => openExtractors("configTables")}
                        >
                            Create Extractors
                        </Button>
                    </Stack>
                }
            >
                <>
                    <strong className="normal">
                        Enter datasetRID to get schema details
                    </strong>
                    <br />
                    <br />
                    <Grid item xs={7}>
                        <FormControl
                            sx={{ m: 1 }}
                            fullWidth
                            variant=
                            "outlined"

                        >
                            <DataField id="foundry-dataserId"
                                label="datasetRID"
                                name="datasetRID"
                                value={datasetRID}
                                error={dataSetError}
                                onChange={handleChange}
                                type="text"
                                required
                            />
                        </FormControl>
                    </Grid>
                </>
                <br />
            </CustomizedDialogs>
        </>
    )
}

export default FoundrySelection;